export default "__VITE_ASSET__BRBASnAF__"